module.exports = __webpack_public_path__ + "img/deskshelf.ef079ec7.png";